/**
 * @module gdprCookie
 */

/**
 * @param {Cookie} Cookies - Object from Cookies-module
 * @param {object} gdprCookieContainer - DOM object with gdpr elements
 */

module.exports = function(Cookies, gdprCookieContainer) {

    // Start Microsoft Clarity Consent
    window.addEventListener( 'consentGranted', () => {
        const waitForClarity = ( callback, maxAttempts = 10, interval = 500 ) => {
            let attempts = 0;
            const checkClarity = setInterval( () => {
                if ( typeof window.clarity === 'function' ) {
                    clearInterval( checkClarity );
                    callback();
                } else if ( attempts >= maxAttempts ) {
                    clearInterval( checkClarity );
                    console.warn( 'Failed to load window.clarity after maximum attempts' );
                }
                attempts++;
            }, interval );
        };

        waitForClarity( () => {
            window.clarity( 'consent' );
        } );
    } );
    // End Microsoft Clarity Consent

    const cookieName = 'eu_cookies_acknowledged';
    if (!Cookies.get(cookieName)) {
        gdprCookieContainer.classList.remove('d-none');
        gdprCookieContainer.classList.add('d-flex');
    } else {
        // Check "consentMode" in localStorage for personalization_storage is granted
        const consentModeStorage = JSON.parse( localStorage.getItem( 'consentMode' ) || '{}' );
        if ( consentModeStorage.personalization_storage === 'granted' ) {
            window.dispatchEvent( new Event( 'consentGranted' ) );
        }
    }

    gdprCookieContainer.querySelector('.tuna_gdpr__cookie-button').addEventListener('click', (e) => {
        e.preventDefault();
        Cookies.create(cookieName, '1', '1y');
        const consentMode = {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            personalization_storage: 'granted',
            functionality_storage: 'granted',
            security_storage: 'granted',
        };
        setConsent(consentMode);
        gdprCookieContainer.remove();
    });

    document.querySelector('.cookie-accept-btn').addEventListener('click', (e) => {
        e.preventDefault();
        const checkboxNonNecessary = document.querySelector('.checkbox-non-necessary');
        let consentMode = {
            ad_storage: 'denied',
            analytics_storage: 'granted',
            personalization_storage: 'denied',
            functionality_storage: 'granted',
            security_storage: 'granted',
        };
        if ( checkboxNonNecessary.checked ) {
            consentMode = {
                ad_storage: 'granted',
                analytics_storage: 'granted',
                personalization_storage: 'granted',
                functionality_storage: 'granted',
                security_storage: 'granted',
            }
        }
        setConsent(consentMode);
        Cookies.create(cookieName, '1', '1y');
        gdprCookieContainer.remove();
    } );

    function setConsent( consentMode ) {
        if (typeof gtag === "function") {
            gtag( 'consent', 'update', consentMode );
            localStorage.setItem( 'consentMode', JSON.stringify( consentMode ) );
        }
        // Consent granted by click Accept
        if ( consentMode.personalization_storage === 'granted' ) {
            window.dispatchEvent( new Event( 'consentGranted' ) );
        }
    }
}; // exports